// MOBILE ONLY - targeted fix for collection pages while preserving homepage functionality
document.addEventListener('DOMContentLoaded', function() {
  console.log("Mobile menu fix with collection page targeting loaded");
  
  // Function to fix mobile menu on any page
  function fixMobileMenu() {
    // Only run on mobile screens
    if (window.innerWidth > 749) return;
    
    // Detect if we're on a collection page
    const isCollectionPage = window.location.pathname.includes('/collections/') || 
                            document.querySelector('.collection-filters') || 
                            document.querySelector('.facets-container') ||
                            document.querySelector('.category-navigation');
    
    console.log("Is collection page:", isCollectionPage);
    
    // Find all possible menu buttons
    const menuButtons = document.querySelectorAll('.header__icon--menu, [aria-controls="menu-drawer"], .menu-toggle');
    
    menuButtons.forEach(button => {
      if (button && !button._fixAdded) {
        button._fixAdded = true;
        console.log("Found menu button, adding handler");
        
        button.addEventListener('click', function(e) {
          console.log("Menu button clicked");
          
          // Find all possible menu drawers
          const menuDrawers = document.querySelectorAll('.menu-drawer, .mobile-menu, .mobile-nav-wrapper');
          
          menuDrawers.forEach(drawer => {
            if (drawer) {
              console.log("Found menu drawer, applying fixes");
              
              // Toggle menu visibility
              if (drawer.classList.contains('active') || 
                  drawer.classList.contains('is-open') ||
                  drawer.getAttribute('aria-hidden') === 'false') {
                // Close menu
                drawer.classList.remove('active', 'is-open');
                drawer.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('overflow-hidden', 'menu-open');
                
                // Remove overlay
                if (document.getElementById('collection-menu-overlay')) {
                  document.getElementById('collection-menu-overlay').style.display = 'none';
                }
              } else {
                // Open menu
                drawer.classList.add('active', 'is-open');
                drawer.setAttribute('aria-hidden', 'false');
                document.body.classList.add('overflow-hidden', 'menu-open');
                
                // Force menu to be visible and scrollable
                drawer.style.display = 'block';
                drawer.style.visibility = 'visible';
                drawer.style.opacity = '1';
                drawer.style.transform = 'translateX(0)';
                drawer.style.backgroundColor = 'white';
                drawer.style.color = 'black';
                drawer.style.zIndex = '9999999'; // Very high z-index
                drawer.style.height = '100vh';
                drawer.style.width = '85%';
                drawer.style.position = 'fixed';
                drawer.style.top = '0';
                drawer.style.left = '0';
                drawer.style.overflowY = 'scroll';
                drawer.style.webkitOverflowScrolling = 'touch';
                drawer.style.touchAction = 'pan-y';
                drawer.style.boxShadow = '0 0 20px rgba(0,0,0,0.5)';
                
                // For collection pages, create an overlay
                if (isCollectionPage) {
                  if (!document.getElementById('collection-menu-overlay')) {
                    const overlay = document.createElement('div');
                    overlay.id = 'collection-menu-overlay';
                    overlay.style.position = 'fixed';
                    overlay.style.top = '0';
                    overlay.style.left = '0';
                    overlay.style.width = '100%';
                    overlay.style.height = '100%';
                    overlay.style.backgroundColor = 'rgba(0,0,0,0.5)';
                    overlay.style.zIndex = '9999998'; // Just below menu
                    document.body.appendChild(overlay);
                  } else {
                    document.getElementById('collection-menu-overlay').style.display = 'block';
                  }
                }
                
                // Apply to all possible menu containers
                const menuContainers = drawer.querySelectorAll('*');
                menuContainers.forEach(container => {
                  // Skip non-container elements
                  if (container.tagName === 'BR' || container.tagName === 'HR') return;
                  
                  container.style.visibility = 'visible';
                  container.style.display = container.tagName === 'A' || 
                                           container.tagName === 'BUTTON' || 
                                           container.classList.contains('menu-item') ? 
                                           'block' : '';
                  container.style.opacity = '1';
                  
                  // Enable scrolling on containers
                  if (container.clientHeight > 50) {
                    container.style.maxHeight = 'none';
                    container.style.overflow = 'visible';
                    container.style.touchAction = 'pan-y';
                  }
                  
                  // Prevent touch events from being canceled
                  container.addEventListener('touchmove', function(e) {
                    e.stopPropagation();
                  }, { passive: true });
                });
              }
            }
          });
        });
      }
    });
    
    // Find and fix any already open menus
    const openMenus = document.querySelectorAll('.menu-drawer.is-open, .menu-drawer.active, .mobile-menu.is-open');
    openMenus.forEach(menu => {
      menu.style.overflowY = 'scroll';
      menu.style.webkitOverflowScrolling = 'touch';
      menu.style.touchAction = 'pan-y';
      menu.style.zIndex = '9999999'; // Very high z-index
    });
  }
  
  // Add targeted mobile menu styles
  const styleEl = document.createElement('style');
  styleEl.textContent = `
    @media screen and (max-width: 749px) {
      /* Universal menu button visibility */
      .header__icon--menu, 
      [aria-controls="menu-drawer"],
      .menu-toggle {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
      
      /* Universal menu drawer styling */
      .menu-drawer.is-open,
      .menu-drawer.active,
      .mobile-menu.is-open,
      .mobile-nav-wrapper.active {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
        transform: translateX(0) !important;
        background-color: white !important;
        color: black !important;
        z-index: 9999999 !important; /* Very high z-index */
        height: 100vh !important;
        width: 85% !important;
        max-width: 350px !important;
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        overflow-y: scroll !important;
        -webkit-overflow-scrolling: touch !important;
        touch-action: pan-y !important;
        box-shadow: 0 0 10px rgba(0,0,0,0.2) !important;
      }
      
      /* Collection page specific fixes */
      body.collection .menu-drawer.is-open,
      body.collection .menu-drawer.active,
      body.collection .mobile-menu.is-open,
      body.collection .mobile-nav-wrapper.active,
      body[class*="collection-"] .menu-drawer.is-open,
      body[class*="collection-"] .menu-drawer.active,
      body[class*="collection-"] .mobile-menu.is-open,
      body[class*="collection-"] .mobile-nav-wrapper.active {
        z-index: 9999999 !important;
      }
      
      /* Lower z-index for collection elements */
      .announcement-bar,
      .announcement-bar-section,
      .collection-filters,
      .facets-container,
      .category-navigation {
        z-index: 10 !important;
      }
      
      /* Collection menu overlay */
      #collection-menu-overlay {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        height: 100% !important;
        background-color: rgba(0,0,0,0.5) !important;
        z-index: 9999998 !important; /* Just below menu */
      }
      
      /* Ensure menu items are visible */
      .menu-drawer a,
      .menu-drawer button,
      .menu-drawer .menu-drawer__menu-item,
      .mobile-menu a,
      .mobile-menu .mobile-nav__item,
      .mobile-nav-wrapper a {
        display: block !important;
        padding: 12px 15px !important;
        color: black !important;
        font-size: 16px !important;
        border-bottom: 1px solid rgba(0,0,0,0.1) !important;
        touch-action: pan-y !important;
        text-decoration: none !important;
      }
      
      /* Ensure all containers are scrollable */
      .menu-drawer__navigation,
      .menu-drawer__inner-container,
      .mobile-nav__table,
      .mobile-nav,
      .mobile-menu-container {
        height: auto !important;
        max-height: none !important;
        overflow-y: visible !important;
        padding-bottom: 150px !important;
        touch-action: pan-y !important;
      }
    }
  `;
  document.head.appendChild(styleEl);
  
  // Run on initial load for mobile only
  if (window.innerWidth <= 749) {
    fixMobileMenu();
    
    // Try again after delays to catch dynamically loaded elements
    setTimeout(fixMobileMenu, 300);
    setTimeout(fixMobileMenu, 1000);
  }
  
  // Run on resize, but only for mobile
  window.addEventListener('resize', function() {
    if (window.innerWidth <= 749) {
      fixMobileMenu();
    }
  });
  
  // Add global touch handlers
  document.addEventListener('touchmove', function(e) {
    if (window.innerWidth <= 749) {
      const menuDrawers = document.querySelectorAll('.menu-drawer.is-open, .menu-drawer.active, .mobile-menu.is-open');
      menuDrawers.forEach(drawer => {
        if (drawer && drawer.contains(e.target)) {
          e.stopPropagation();
        }
      });
    }
  }, { passive: true });
  
  // Handle page changes (for single-page apps)
  const observer = new MutationObserver(function(mutations) {
    if (window.innerWidth <= 749) {
      fixMobileMenu();
    }
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
});